import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import { MatterSearchComponent } from '../../common/matter-search/matter-search.component';

import { Vendor } from '../../../models/vendor';

import { ModalService } from '../../../services/common/modal.service';
import { NotyService } from '../../../services/common/noty.service';
import { VendorService } from '../../../services/accounting/vendor.service';

@Component({
  selector: 'app-contact-vendors',
  templateUrl: './contact-vendors.component.html',
  styleUrls: ['./contact-vendors.component.scss'],
})
export class ContactVendorsComponent implements OnInit {
  /**
   * Contact's id for the sidebar
   */
  @Input() contactId: number;

  /**
   * Number of vendors for this contact
   * @type {number}
   */
  count: number = 0;

  /**
   * Params for billings section query
   * @type {any}
   */
  indexParams: any = {
    include_matters: true,
    page: 1,
    per_page: 20,
  };

  /**
   * Indicates if contact vendors is being loaded from backend
   * @type {boolean}
   */
  loadingVendors: boolean = true;

  /**
   * Indicates if new vendor form is to be showed
   * @type {boolean}
   */
  showNewVendorForm: boolean = false;

  /**
   * contact vendors paginated
   * @type {Array<any>}
   */
  vendors: Array<any>;

  /**
   * Matter search component
   * @param {[type]} 'matterSearch'
   */
  @ViewChild('matterSearch') matterSearchComponent: MatterSearchComponent;

  constructor(private modalService: ModalService, private notyService: NotyService, private vendorService: VendorService) {}

  // Component lifecycle methods
  ngOnInit() {}

  /**
   * Angular Component lifecycle method which is called when one or more member variable change
   * @param {SimpleChanges} changes Object with all changes done to member variables of this class
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.loadVendors();
  }

  // Component methods

  /**
   * Add Matter to Vendor
   * @param {number} matterId Matter Id to be added
   * @param {number} vendorId Vendor Id to be added to
   */
  addMatter(matterId: number, vendorId: number) {
    console.log(matterId);
    this.vendorService
      .addMatter(vendorId, matterId)
      .then((response_json) => {
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Matter added', 'success', 5000, 'topRight');
          this.loadVendors();
        } else this.notyService.notify(response_json.text || 'Error adding matter', 'error', 5000, 'topRight');
      })
      .catch(() => {
        this.notyService.notify('Error adding matter', 'error', 5000, 'topRight');
      });
  }

  /**
   * Delete vendor
   * @param {any} vendor Vendor object
   */
  deleteVendor(vendor: any) {
    this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-danger';
    this.modalService.confirmDialogComponent.open(`<p>Delete Vendor of Id - <strong class='text-danger'>${vendor.id}</strong></p>`).result.then(
      (result) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
        if (result == 'confirmed') {
          this.vendorService
            .deleteVendor(vendor.id)
            .then((response_json) => {
              if (response_json.success) {
                this.notyService.notify(response_json.text || 'Vendor removed', 'info', 5000, 'topRight');
                this.loadVendors();
              } else this.notyService.notify(response_json.text || 'Error removing vendor', 'error', 5000, 'topRight');
            })
            .catch(() => {
              this.notyService.notify('Error removing vendor', 'error', 5000, 'topRight');
            });
        }
      },
      (reason) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
      }
    );
  }

  /**
   * Form saved
   * @param {boolean} event Indicates if formed saved successfully
   */
  formSaved(event: boolean, vendor: Vendor | null = null) {
    if (event && !vendor) {
      if (!vendor) this.loadVendors();
    } else if (!event && vendor) this.loadVendors();
    if (!vendor) this.showNewVendorForm = false;
    else vendor.editing = false;
  }

  /**
   * Load Vendors
   */
  loadVendors(pageNumber: number | null = null) {
    if (pageNumber) this.indexParams.page = pageNumber;
    this.loadingVendors = true;
    this.indexParams.contact_id = this.contactId;
    this.vendorService.getVendors(this.indexParams).then((response_json) => {
      this.loadingVendors = false;
      this.count = response_json.count;
      this.vendors = response_json.results;
    });
  }

  removeMatter(matterId: number, vendorId: number) {
    this.vendorService
      .removeMatter(vendorId, matterId)
      .then((response_json) => {
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Matter removed', 'success', 5000, 'topRight');
          this.loadVendors();
        } else this.notyService.notify(response_json.text || 'Error removing matter', 'error', 5000, 'topRight');
      })
      .catch(() => {
        this.notyService.notify('Error removing matter', 'error', 5000, 'topRight');
      });
  }
}
